import React from 'react'
import Dot from './Dot'

import { LBBox } from './ApplicationStepLBIntroduction'
import { defaultMargin } from 'components/BaseComponents/constants'

interface Props {
    currentStep: number
    stepLength: number
}

const StepDots: ({ currentStep, stepLength }: Props) => JSX.Element = ({ currentStep, stepLength }: Props) => {
    return (
        <LBBox
            style={{
                display: 'flex',
                flexDirection: 'row',
                gap: defaultMargin,
                alignSelf: 'center',
            }}
        >
            {Array.from(
                { length: stepLength + 1 },
                (value, index) => index >= 1 && <Dot key={index} isActiveStep={currentStep === index} />
            )}
        </LBBox>
    )
}

export default StepDots
